import type { ReactElement, ReactNode } from 'react';

import { Stack } from '@mui/material';

import type { BrowserTabFlowName } from 'common/utils/browserTabFlowOwner';
import { useBrowserTabFlowOwner } from 'common/utils/browserTabFlowOwner';
import { Loading } from 'common/utils/loading';

interface Props {
    flowName: BrowserTabFlowName;
    /** True while the flow may only be used in the tab that owns it. */
    confineToOwnerTab: boolean;
    renderFallback: (takeOver: { takeOverFlowInThisTab: () => void }) => ReactNode;
    children: ReactNode;
}

export const BrowserTabFlowGate = ({ flowName, confineToOwnerTab, renderFallback, children }: Props): ReactElement => {
    const { flowOwnership, takeOverFlowInThisTab } = useBrowserTabFlowOwner(flowName);

    if (!confineToOwnerTab || flowOwnership === 'ownedByThisTab') {
        return <>{children}</>;
    }

    if (flowOwnership === 'checking') {
        return (
            <Stack sx={{ position: 'fixed', inset: 0, alignItems: 'center', justifyContent: 'center' }}>
                <Loading isLoading />
            </Stack>
        );
    }

    return <>{renderFallback({ takeOverFlowInThisTab })}</>;
};
